<template>
    <div class="flex flex-column">
        <div v-if="exchange.isConnected" class="">
            <div class="flex flex-row align-items-center mb-4">
                <div class="text-green-500 "><i class="pi pi-check-circle mr-1"></i> Связь с аккаунтом биржи установлена.</div>
                <div class="ml-2">
                    <SpinnerWrapper :loading="isRefreshProcessed">
                    <Button @click="handleRefresh(exchange.exchangeId)" label="Обновить данные" class="p-button-text p-button-sm" />
                    </SpinnerWrapper>
                </div>
            </div>
            <div class="mb-2">Данные на момент {{exchange.connectedAt}} UTC:</div>
            <div v-for="balance in exchange.allBalances" class="flex flex-row mb-2">
                <div class="w-4rem">{{balance.symbol}}:</div>
                <div class="w-8rem">{{balance.available}}</div>
                <div class="w-8rem">${{balance.usdt_value}}</div>
                <div class="w-8rem"><span v-if="balance.num_deals > 0">Сделок: {{balance.num_deals}}</span></div>
                <div v-if="balance.symbol!=='USDT'" class="w-10rem"><span class="cursor-pointer text-blue-500" @click="handleSell(balance.symbol, balance.available)">конвертация в USDT</span></div>
            </div>
            <div class="flex flex-row mb-2">
                <div class="w-4rem"></div>
                <div class="w-8rem">Итого</div>
                <div class="w-8rem">${{sumUsdtBalance(exchange.allBalances)}}</div>
            </div>
        </div>
        <div v-else>
            <div class="text-red-500" v-if="exchange.apiKey && exchange.secretKey">Связь с аккаунтом биржи не установлена. Проверьте ключи. У ключей должна быть привязка к IP {{serverIp}}</div>
            <SpinnerWrapper :loading="isRefreshProcessed">
                <Button @click="handleRefresh(exchange.exchangeId)" label="Обновить данные" class="p-button-text p-button-sm" />
            </SpinnerWrapper>
        </div>
    </div>
</template>

<script>
    import Button from "primevue/button";
    import SpinnerWrapper from "@/Components/SpinnerWrapper";
    import helpers from "@/helpers";
    import { router } from '@inertiajs/vue2'

    export default {
        components: {Button, SpinnerWrapper},
        props: {
            exchange: Object,
            serverIp: String,
        },
        data(){
            return {
                isRefreshProcessed: false,
            }
        },
        methods:{
            sumUsdtBalance(balances){
                let sum = 0;
                balances.forEach((item) => {
                    if(item.usdt_value){
                        sum += parseFloat(item.usdt_value);
                    }
                });
                return this.round(sum, 2);
            },
            handleSell(symbol, sum)
            {
                this.$confirm.require({
                    message: 'Все сделки будут удалены, в статистику работы бота результат продажи не попадёт. ' + sum +' '+ symbol + ' будет сконвертировано в USDT по текущему рыночному курсу. Продолжить?',
                    header: 'Подтверждение',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.$inertia.post(`/settings/sell/`, {symbol, sum}, {
                            onSuccess: (page) => {
                                this.$emit('refresh', this.exchange.exchangeId);
                            }
                        });
                    },
                    reject: () => {

                    }
                });

            },
            handleRefresh(exchangeId){
                this.isRefreshProcessed = true;
                router.post(`/settings/refresh_exchange/`, {"exchangeId": exchangeId}, {
                    onSuccess: (page) => {
                        this.isRefreshProcessed = false;
                        this.$emit('refresh', this.exchange.exchangeId);
                    }
                });
            },
            ...helpers
        }
    };
</script>
